import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { InformationCard } from 'src/components/information-card';
import { ParagraphPlaceholder, ParagraphPlaceholderProps } from 'src/components/paragraph-placeholder';
import { defaultParagraphPlaceholderStyles } from 'src/components/paragraph-placeholder/default-paragraph-placeholder-styles';
import { withUpdatedTheme } from 'src/components/theme';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorSecondary200 } from 'src/styles/colors';
import { placeholder } from 'src/styles/mixins';
import { spacing1, spacing3, spacing4, spacing6, spacing7, spacing8, spacing10, spacing17 } from 'src/styles/spacing';

export const StyledTitle = styled(Typography)`
  text-align: center;
  margin-bottom: ${spacing1};
  margin-top: ${spacing8};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-top: ${spacing17};
  }
`;

export const StyledText = styled(Typography)`
  text-align: center;
  margin-bottom: ${spacing3};
`;

export const StyledCard = styled(InformationCard)`
  &:not(:first-child) {
    margin-bottom: ${spacing4};
  }
`;

export const StyledCardTitlePlaceholder = styled.div`
  ${placeholder};
  height: 24px;
  max-width: 440px;
`;

export const StyledProductPlaceholder = styled.div`
  display: flex;
  align-items: center;
  padding: ${spacing6} 0 ${spacing7};
  margin-bottom: ${spacing1};
  border-bottom: 1px solid ${colorSecondary200};
`;

export const StyledProductDescription = styled.div`
  margin-left: ${spacing3};
  flex: 1 1 0;
`;

export const StyledImagePlaceholder = styled.div`
  ${placeholder};
  height: 58px;
  border-radius: 100%;
  flex: 0 0 58px;
`;

export const StyledProductsSummary = styled.div`
  margin-top: ${spacing6};
`;

export const StyledInformationContainer = styled.div`
  margin-top: ${spacing7};
  margin-bottom: ${spacing6};
`;

export const StyledSummaryPlaceholder = withUpdatedTheme<ParagraphPlaceholderProps>({
  paragraphPlaceholder: {
    ...defaultParagraphPlaceholderStyles,
    paragraph: {
      ...defaultParagraphPlaceholderStyles.paragraph,
      width: '372px',
    },
  },
})(ParagraphPlaceholder);

export const StyledInformationPlaceholder = withUpdatedTheme<ParagraphPlaceholderProps>({
  paragraphPlaceholder: {
    ...defaultParagraphPlaceholderStyles,
    container: {
      ...defaultParagraphPlaceholderStyles.container,
      marginBottom: spacing10,
    },
  },
})(ParagraphPlaceholder);
